import React from "react";
import { usePermission } from "features/../../../shared/components/auth";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import InitialScheduleTermTable from "./InitialScheduleTermTable";
import {
  listAdditionalManagedVolumeUnitTerms,
  getAdditionalManagedVolumeUnitTerms,
  createAdditionalManagedVolumeUnitTerms,
  updateAdditionalManagedVolumeUnitTerms,
  deleteAdditionalManagedVolumeUnitTerms,
  downloadAdditionalManagedVolumeUnitTerms,
  approveAdditionalManagedVolumeUnitTerms,
  makeAdditionalManagedVolumeUnitTermsLive,
} from "./actions";

const AdditionalManagedVolumeUnitTermsTable = ({ dealerId }) => {
  const canApprove = usePermission(
    Targets.AdditionalManagedVolumeUnits,
    Actions.Approve,
  );
  const canDownload = usePermission(
    Targets.AdditionalManagedVolumeUnits,
    Actions.Download,
  );

  return (
    <InitialScheduleTermTable
      dealerId={dealerId}
      title="Additional Managed Volume Units Terms"
      triggerText="Upload Additional Managed Volume Units Terms"
      listAction={listAdditionalManagedVolumeUnitTerms}
      getAction={getAdditionalManagedVolumeUnitTerms}
      createAction={createAdditionalManagedVolumeUnitTerms}
      updateAction={updateAdditionalManagedVolumeUnitTerms}
      deleteAction={deleteAdditionalManagedVolumeUnitTerms}
      downloadAction={downloadAdditionalManagedVolumeUnitTerms}
      approveAction={approveAdditionalManagedVolumeUnitTerms}
      makeLiveAction={makeAdditionalManagedVolumeUnitTermsLive}
      canApprove={canApprove}
      canDownload={canDownload}
    />
  );
};

export default AdditionalManagedVolumeUnitTermsTable;
